export const isInt = (value) => {
    const regex = /^(?:[-+]?(?:0|[1-9]\d*))$/;
    return regex.test(value);
};
export const isFloat = (value) => {
    const regex = /^(?:[-+]?(?:\d+))?(?:\.\d*)?(?:[eE][+-]?(?:\d+))?$/;
    return regex.test(value);
};
